import { Store } from 'src/store/index';

const getCurrentFormat = (store: Store) => store.format.currentFormat;

export default getCurrentFormat;
